export default __webpack_public_path__ + "static/src/assets/images/icons/itrade7 EIF_e-statements_icon_pdf.svg";